import 'css-chunksrc/client/pages/searchPage/loader/element/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_1ud0u_1",
  "allocation": "_allocation_1ud0u_1"
};